import React from 'react';
import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CardIcon from '@/components/Card/CardIcon';
import CardFooter from '@/components/Card/CardFooter';
import { makeStyles } from '@mui/styles';
import styles from '@/assets/jss/material-dashboard-react/views/dashboardStyle';

const useStyles = makeStyles(styles);

const DashboardInfoCard = ({
  color,
  icon,
  category,
  value,
  footer,
  onHeaderClick,
  children,
  style,
}) => {
  const classes = useStyles();
  return (
    <Card
      style={{
        height: '75%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        ...style,
      }}>
      <CardHeader color={color} stats icon onClick={onHeaderClick}>
        <CardIcon color={color}>{icon}</CardIcon>
        <p className={classes.cardCategory}>{category}</p>
        <h4 className={classes.cardTitle}>
          <small>{value}</small>
        </h4>
      </CardHeader>
      <CardFooter stats style={{ marginTop: 'auto' }}>
        {footer}
      </CardFooter>
      {children}
    </Card>
  );
};

export default DashboardInfoCard;
